// Navigation model. Every href points at a route or anchor that exists today.

export const megaMenus = [
  {
    id: "network",
    label: "Our Network",
    description: "The investigators, sites and specialties behind KUR.",
    links: [
      { label: "Doctors", href: "/network/doctors", text: "Our investigator network" },
      { label: "Locations", href: "/network/locations", text: "KUR clinical research sites" },
      { label: "Therapeutic Areas", href: "/network/therapeutic-areas", text: "Specialties across the network" },
    ],
    feature: { label: "Join our network", href: "/physicians#contact", text: "Become a KUR investigator." },
  },
  {
    id: "sponsors",
    label: "For Sponsors",
    description: "Site network, startup speed and centralized quality.",
    links: [
      { label: "Overview", href: "/sponsors", text: "Why sponsors choose KUR" },
      { label: "Solutions & startup", href: "/sponsors#solutions", text: "Study startup and centralized solutions" },
      { label: "Therapeutic areas", href: "/sponsors#therapeutic", text: "Acute, chronic, vaccine and diagnostic trials" },
      { label: "Network & demographics", href: "/sponsors#demographics", text: "Who our sites serve" },
    ],
    feature: { label: "Contact sponsor team", href: "/sponsors#contact", text: "Discuss a protocol with KUR." },
  },
  {
    id: "physicians",
    label: "For Physicians",
    description: "Add research to your practice with KUR infrastructure.",
    links: [
      { label: "Overview", href: "/physicians", text: "Why partner with KUR" },
      { label: "Practice assessment", href: "/physicians#assessment", text: "Is research right for your practice" },
      { label: "Implementation", href: "/physicians#implementation", text: "Getting your site ready" },
      { label: "Site management", href: "/physicians#management", text: "Ongoing operational support" },
    ],
    feature: { label: "Partner with KUR", href: "/physicians#contact", text: "Start a conversation." },
  },
  {
    id: "patients",
    label: "For Patients",
    description: "Learn about clinical research and where to start.",
    links: [
      { label: "What to expect", href: "/patients#expect", text: "How taking part works" },
      { label: "What is clinical research?", href: "/patients#faq", text: "Common questions answered" },
    ],
    feature: { label: "Talk to a patient advocate", href: "/patients#contact", text: "We will reach out to you." },
  },
  {
    id: "about",
    label: "About KUR",
    description: "Who we are and how we work.",
    links: [
      { label: "About KUR", href: "/about", text: "Our story and mission" },
      { label: "Leadership", href: "/about#executives", text: "The team behind KUR" },
      { label: "Investigators", href: "/network/doctors", text: "Our investigator network" },
      { label: "Careers", href: "/job-application", text: "Join KUR" },
    ],
    feature: { label: "Contact KUR", href: "/contact", text: "We would like to hear from you." },
  },
];

export const footerColumns = [
  {
    title: "Sponsors",
    links: [
      { label: "Overview", href: "/sponsors" },
      { label: "Solutions", href: "/sponsors#solutions" },
      { label: "Therapeutic areas", href: "/sponsors#therapeutic" },
      { label: "Contact sponsors", href: "/sponsors#contact" },
    ],
  },
  {
    title: "Physicians",
    links: [
      { label: "Overview", href: "/physicians" },
      { label: "Assessment", href: "/physicians#assessment" },
      { label: "Implementation", href: "/physicians#implementation" },
      { label: "Partner with KUR", href: "/physicians#contact" },
    ],
  },
  {
    title: "Patients",
    links: [
      { label: "What to expect", href: "/patients#expect" },
      { label: "FAQ", href: "/patients#faq" },
      { label: "Talk to us", href: "/patients#contact" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About KUR", href: "/about" },
      { label: "Investigators", href: "/network/doctors" },
      { label: "Locations", href: "/network/locations" },
      { label: "Careers", href: "/job-application" },
      { label: "Contact", href: "/contact" },
    ],
  },
];
